import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'

import useAuth from '@/api/hooks/useAuth'
import Button from '@/atoms/Button/Button'
import { showModal } from '@/store/slices/modal'

function MainSection() {
  const { t } = useTranslation('forCreators')
  const { data: user } = useAuth('user')

  const openAuthModal = () => showModal('auth', 'providers')

  return (
    <div className="flex flex-col items-start md:flex-row md:space-x-16">
      <div className="md:w-3/5">
        <div className="flex flex-col">
          <h1 className="text-xl text-[#4f5585] font-medium lg:text-2xl">
            {t('main_title_1')}
          </h1>
          <span className="my-1 text-[#4f5585] text-xl font-medium lg:text-2xl">
            {t('main_title_2')}
          </span>
          <span className="text-[#9082c0]">
            {t('main_title_description_1')}
          </span>
          <span className="text-[#9082c0]">
            {t('main_title_description_2')}
          </span>
        </div>
        <div className="flex flex-col max-w-2xl mt-6 space-y-4 md:mt-12 lg:text-xl">
          <p className="text-sm text-gray-100">{t('description')}</p>
        </div>
        {!user && (
          <Button
            text={t('signup')}
            variant="flat-full"
            className="w-full p-2 mx-auto mt-12 text-sm md:mx-0 md:text-base max-w-260px"
            onClick={openAuthModal}
          />
        )}
      </div>
      <div className="flex-shrink-0 max-w-3xl mx-auto mt-16 md:w-2/5 3xs:w-4/5 xl:-mt-8 md:mt-0">
        <Image
          src="/images/for-creators/main_image.png"
          width={869}
          height={869}
          loading="eager"
        />
      </div>
    </div>
  )
}

export default MainSection
